import React from 'react'
import { Typography } from '@mui/material'
import { Trans } from 'react-i18next'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/** Dashboard chart date range step component */
export const DashboardChartFiltersStep: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <>
      <Trans i18nKey="emobility.tour.dashboard-chart-filters" components={{ strong: <strong /> }} />
      <Typography mt={2}>{t('emobility.tour.dashboard-chart-filters-content')}</Typography>
    </>
  )
}
